module.exports = __webpack_public_path__ + "img/l.073cc805.jpg";